<template>
    <toolbar-option type="stacked">
        <template v-if="slider" slot="secondary">
            <dropdown
                :value="side"
                :options="sideOptions"
                native
                @input="onSideInput"
            />
        </template>

        <template slot="secondary-2">
            <dropdown
                :value="unit"
                :options="unitOptionsNew"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="margin-slider" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'margin',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Margin',
            tailwindDefinitionProp: 'margin',
            defaultUnit: 'rem',
        };
    },

    computed: {
        unitOptionsNew() {
            const options = this.unitOptions;

            options.unshift({ text: 'None', value: '' });

            return options;
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'boxed') this.onConflict('boxed');
        },
    },

    methods: {
        onConflict(type) {
            switch (type) {
                // fired when the .fu-boxed class is added, since it uses margin
                case 'boxed': {
                    const state = this.state || 'all';
                    const allMarginClass = this.selectedElements[0].flexClassCollection.margin[state].default;

                    let allMarginValue;

                    if (allMarginClass) {
                        allMarginValue = getClassDefinition(allMarginClass).value;
                    }

                    this.removeFlexClass(['default', 'l', 'r', 'x']);

                    // if an "all sides" margin value was detected, then we need to readd the top and bottom margin values
                    // ... as the boxed width option only needs to override the left and right values
                    if (allMarginValue) {
                        this.addFlexClass({
                            side: 'y',
                            value: allMarginValue,
                        });

                        this.onSelectedElement();
                    } else {
                        this.side = '';
                    }

                    break;
                }

                default:
                    this.side = '';
                    this.removeFlexClass();
            }

            this.sliderIndex = this.themeObjectValues.indexOf('0rem');
            this.unit = this.defaultUnit;
        },
    },
};
</script>
